import { Component } from '@angular/core'

@Component({
  selector: 'bdg-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
})
export class PageHeaderComponent {}
